export default __webpack_public_path__ + "media/zurb/img/events/wired/raft/raft-3-d89941e0f03ffafd83207a57b5b509e6.png";